import { gql } from 'apollo-angular';

export const CREATE_EXPENSE = gql`
  mutation createExpense($input: CreateExpenseInput!) {
    createExpense(input: $input) {
      id
      expenseDate
      expenseType
      amount
      tax
      paidBy
      paymentMethod
      bankAccountId
      creditCardId
      isCheque
      chequeNo
      chequeDate
      referenceNo
      description
      attachmentUrl
      branchData {
        branchName
      }
      accountData {
        accountName
      }
    }
  }
`;

export const UPDATE_EXPENSE = gql`
  mutation updateExpense($id: Int!, $input: UpdateExpenseInput!) {
    updateExpense(id: $id, input: $input) {
      id
      expenseDate
      expenseType
      amount
      tax
      paymentMethod
      expenseStatus
      description
      referenceNo
      updatedAt
      branchData {
        branchName
      }
      accountData {
        accountName
      }
      paidByData {
        firstName
        lastName
      }
    }
  }
`;

export const DELETE_EXPENSE = gql`
  mutation deleteExpense($id: Int!) {
    deleteExpense(id: $id) {
      id
      success
      message
    }
  }
`;

export const REMOVE_EXPENSE = gql`
  mutation removeExpense($id: Int!) {
    removeExpense(id: $id)
  }
`;

export const APPROVE_EXPENSE = gql`
  mutation approveExpense($approveExpenseInput: ApproveExpenseInput!) {
    approveExpense(approveExpenseInput: $approveExpenseInput) {
      id
      expenseStatus
      approvedByData {
        id
        firstName
        lastName
      }
      approvedAt
    }
  }
`;

export const REJECT_EXPENSE = gql`
  mutation rejectExpense($rejectExpenseInput: RejectExpenseInput!) {
    rejectExpense(rejectExpenseInput: $rejectExpenseInput) {
      id
      expenseStatus
      rejectedByData {
        id
        firstName
        lastName
      }
      rejectionReason
      rejectedAt
    }
  }
`;

export const EXPORT_EXPENSES_TO_PDF = gql`
  mutation exportExpensesToPDF(
    $input: ExpenseExportInput!
    $fields: [String!]!
  ) {
    exportExpensesToPDF(input: $input, fields: $fields)
  }
`;

export const EXPORT_EXPENSES_TO_CSV = gql`
  mutation exportExpensesToCSV(
    $input: ExpenseExportInput!
    $fields: [String!]!
  ) {
    exportExpensesToCSV(input: $input, fields: $fields)
  }
`;

export const APPROVE_OR_REJECT_EXPENSE = gql`
  mutation modifyExpenseStatus($id: Int!, $input: UpdateExpenseInput!) {
    modifyExpenseStatus(id: $id, input: $input) {
      id
      branchId
      expenseDate
      expenseType
      accountId
      amount
      approvedBy
      expenseStatus
    }
  }
`;
